/* Visibility only: no app removal, tracking, requests or purchase mutations. */
(() => {
  if (!('IntersectionObserver' in window)) return;
  const scope = document.getElementById('mainContent');
  if (!scope) return;
  const mobile = window.matchMedia('(max-width: 768px)');
  // Sticky purchase bars are handled in CSS; hidden bars still intersect the viewport.
  const selector = 'sht-prd-frm button[name="add"], button[name="checkout"]';
  const targets = new Map();
  const update = () => document.body.classList.toggle(
    'inochi-purchase-in-view',
    mobile.matches && Array.from(targets.values()).some(Boolean)
  );
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (scope.contains(entry.target)) targets.set(entry.target, entry.isIntersecting);
    });
    update();
  }, { rootMargin: '32px', threshold: 0 });
  const sync = () => {
    targets.forEach((visible, target) => {
      if (!scope.contains(target)) {
        observer.unobserve(target);
        targets.delete(target);
      }
    });
    scope.querySelectorAll(selector).forEach(target => {
      if (!targets.has(target)) {
        targets.set(target, false);
        observer.observe(target);
      }
    });
    update();
  };
  sync();
  // Shopify replaces cart/variant markup without a full navigation.
  let scheduled = false;
  new MutationObserver(records => {
    const affectsControls = records.some(record =>
      [...record.addedNodes, ...record.removedNodes].some(node =>
        node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector))
      )
    );
    if (!affectsControls || scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; sync(); });
  }).observe(scope, { childList: true, subtree: true });
  mobile.addEventListener('change', update);
})();
